export enum LicenseTypes {
    ADMIN = 'admin',
    VIEWER = 'viewer',
    MOBILE = 'mobile',
}
